"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _arguments = typeof arguments === "undefined" ? void 0 : arguments,
    _this = void 0;

var loadScript = function loadScript(src) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };
  var script = document.createElement('script');
  var head = document.querySelectorAll('head')[0];
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.src = src;

  if (script.addEventListener) {
    script.addEventListener('load', function () {
      callback();
    }, false);
  } else if (script.attachEvent) {
    script.attachEvent('onreadystatechange', function () {
      var target = window.event.srcElement;

      if (target.readyState === 'loaded') {
        callback();
      }
    });
  }

  head.append(script);
};

var issSetInterval = function issSetInterval(fn, time) {
  var value = setInterval(function () {
    console.log('issSetInterval', !document.hidden && document.visibilityState === 'visible');

    if (!document.hidden && document.visibilityState === 'visible') {
      fn();
    }
  }, time);
  return value;
};

var issSetTimeout = function issSetTimeout(fn, time) {
  var value = setTimeout(function () {
    console.log('issSetInterval', !document.hidden && document.visibilityState === 'visible');

    if (!document.hidden && document.visibilityState === 'visible') {
      fn();
    }
  }, time);
  return value;
};

var debounce = function debounce(operateFunc, interval) {
  var timer;
  return function () {
    var context = _this;
    var args = _arguments;
    var callNow = !timer;

    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    timer = setTimeout(function () {
      timer = null;
    }, interval);
    if (callNow) operateFunc.apply(context, args);
  };
};

var throttle = function throttle(func, limit) {
  var lastFunc;
  var lastRan;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;

    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

var _default = {
  debounce: debounce,
  throttle: throttle,
  issSetInterval: issSetInterval,
  issSetTimeout: issSetTimeout,
  loadScript: loadScript
};
exports["default"] = _default;